module.exports = __webpack_public_path__ + "static/media/dashboardbank1.f6ac6857.png";